import Axios from "../../axios.js";
import {loginApiConstants, schoolConstants} from "../../constants/ApiConstant";


export async function signInUser(params) {
    return Axios.post(loginApiConstants.LOGIN_USER, params);
}

export async function registerSchool(params) {
    return Axios.post(schoolConstants.SCHOOL_SAVE, params);
}